import { IntegrationPlatform, SyncDirection, SyncStatus } from '../enums';
import { SyncObjectType } from '../enums/sync-object-type.enum';

export class SyncStatusDto {
  id: string;
  supplierId?: string;
  platformName: IntegrationPlatform;
  objectType: SyncObjectType;
  status: SyncStatus;
  objectId: string;
  updatedAt: Date;
  direction: SyncDirection;
  metadata: any;
}
